
import { LinearProgress } from "@mui/material";
import Grid from '@mui/material/Grid2';

export const Loading = () => {
    return (
        <Grid container width="100%" height="100%" display="flex" alignContent="center" alignItems="center" marginTop={1} marginBottom={1} >
            <Grid  width="100%">
                <LinearProgress variant="indeterminate" />
            </Grid>
        </Grid>
    );
}